import Http from './http'
import PalletDashboard from './pallet/PalletDashboardApi'
import RetailDashboard from './retail/RetailDashboardApi'

export default {
  ...PalletDashboard,
  ...RetailDashboard,

  indexFailures(filter){
    return Http.get(`/dashboards/failures`, {params: {...filter}})
  },
  showFailures(filter){
    let {id} = filter
    console.log({filter});
    if (id){
      return Http.get(`/dashboards/failures/${id}`, {params: {...filter}})
    }
    throw Error('no id found')
  },

	index(filtering){
    let {solution_id, start_date, end_date} = filtering
    return Http.get('/dashboards',{
      params:
      // JSON.stringify(
        {
          ...filtering
          //solution_id,
          //start_date,
          //end_date,
        }
      // )
    })
  },
  show(id, filter){
    return Http.get(`/dashboards/${id}`, {params: filter})
  },

  indexForms(filter){
    return Http.get(`/forms`, {params: filter})
  },
  indexFormDashboard(filter){
    let {solution_id, start_date, end_date} = filter
    return Http.get(`/dashboards`, { params: {...filter} })
  },

  indexReportByUsers(filter){
    return Http.get(`/dashboards/report_by_users`, {params: {...filter}})
  },
}